import { CursorType } from "frontend/canvas-designer-new/cursor-type";
import {
  widgets_cardStackIcon,
  widgets_ganttChartIcon,
  widgets_mindMapIcon,
  widgets_orgChartIcon,
  widgets_tableIcon,
  widgets_taskIcon,
} from "frontend/canvas-designer-new/sidebar/side-menu-items/side-menu-icons";
import { ScrollWithFade } from "../components/scroll-with-fade";
import WidgetMenuItem from "../components/widgets-menu-item";
import { useFeatureFlag } from "frontend/hooks/use-feature-flag/use-feature-flag";
import PadInline from "../components/pad-inline";
import styles from "../components/components.module.css";

export default function WidgetsSubMenu({ onClick }: { onClick: (widget: CursorType) => void }) {
  const newTaskEnabled = useFeatureFlag("new-task-element");

  return (
    <>
      <PadInline>
        <header className={styles.headerStyle}>Widgets</header>
        <div className={styles.subHeadingStyle}>Here you can find all Canvas Widgets</div>
      </PadInline>
      <ScrollWithFade>
        <WidgetMenuItem
          image={widgets_ganttChartIcon}
          title="Gantt chart"
          subtitle="Plan your work using a gantt"
          onClick={() => onClick(CursorType.gantt)}
        />
        <WidgetMenuItem
          image={widgets_orgChartIcon}
          title="Org chart"
          subtitle="Visualize team structures"
          onClick={() => onClick(CursorType.orgChart)}
        />

        <WidgetMenuItem
          image={widgets_mindMapIcon}
          title="Mindmap"
          subtitle="Create mind maps on canvas"
          onClick={() => onClick(CursorType.mindmap)}
        />
        <WidgetMenuItem
          image={widgets_tableIcon}
          title="Table"
          subtitle="Organize data in tables"
          onClick={() => onClick(CursorType.table)}
        />

        <WidgetMenuItem
          image={widgets_cardStackIcon}
          title="Card stack"
          subtitle="Organize your task cards"
          onClick={() => onClick(CursorType.cardStack)}
        />
        <WidgetMenuItem
          image={widgets_taskIcon}
          title="Task"
          subtitle="create a task"
          onClick={() => onClick(newTaskEnabled ? CursorType.task : CursorType.taskCard)}
        />
      </ScrollWithFade>
    </>
  );
}
